import { ProcessingStreamEvent } from '../services/api';

const normalizeVideoIds = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];
  return value.filter((videoId): videoId is string => typeof videoId === 'string' && videoId.length > 0);
};

export const getProcessingEventScopedVideoIds = (
  event?: Pick<ProcessingStreamEvent, 'event_type' | 'payload'> | null,
): string[] => {
  const payload = event?.payload || {};
  const payloadVideoIds = normalizeVideoIds(payload.video_ids);
  const targetVideoIds = normalizeVideoIds(payload?.target?.video_ids);
  const contextVideoIds = normalizeVideoIds(payload?.run_context?.video_ids);

  return Array.from(new Set([...targetVideoIds, ...contextVideoIds, ...payloadVideoIds]));
};
